import TermsConditions from "../components/TermsAndConditions/TermsConditions";


export default {
  name: "TermsAndConditions",
  component:TermsConditions,
  url: "/terms-condition",
  exact: true,
};
